import { useCurrentMove, useSelectedQuote } from '../../../modules/moves'
import PersonnalizedMoveSizePage from '../PersonnalizeMoveSizePage.tsx/PersonnalizedMoveSizePage'
import QuotesPage from '../QuotesPage'
import CheckoutPage from '../CheckoutPage/CheckoutPage'
import QuoteAcceptedPage from '../QuoteAcceptedPage'
import PendingDepositPage from '../PendingDepositPage'

/**
 * this dispatchs to the proper page based on the move status
 * at this point, we know the move is active
 */
const MoveDispatcherPage: React.FC = () => {
  const move = useCurrentMove()
  const selectedQuote = useSelectedQuote()
  const needDeposit = !!move.accounting.paymentProfile?.depositRequest
  const hasDeposit = !!move.deposit

  if (move.quoteAcceptedAt && needDeposit && !hasDeposit) {
    return <PendingDepositPage />
  }

  if (move.quoteAcceptedAt) {
    return <QuoteAcceptedPage />
  }

  if (selectedQuote) {
    return <CheckoutPage />
  }

  if (move.request.content.specialItems?.length && move.request.content.specialItemsPrefilled) {
    return <PersonnalizedMoveSizePage />
  }

  return (
    <QuotesPage />
  )
}

export default MoveDispatcherPage
